import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { alert } from "../../../Utils/toast";
import { GetSpecialistProfileDataType } from "../../../Schema/specialistProfile.types";
import { getCurrentLanguage } from "../../../Utils/sagaHelpers";

export type GetSpecialistProfileLoadAction = {
  type: string;
  payload: {
    id:string | number;
  };
};

export type GetSpecialistProfileData = {
  data: GetSpecialistProfileDataType;
};

const GetSpecialistProfile = new ReduxFetchState<GetSpecialistProfileData, {}, any>(
  "specialistProfile",
);

export function* watchGetSpecialistProfile(action: GetSpecialistProfileLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetSpecialistProfileData = yield axios({
      url: `/api/v1/ai/expert/${action.payload.id}/show`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetSpecialistProfile.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetSpecialistProfile.actions.loadFailure(e.message));
  }
}

export function* specialistProfileSagas() {
  yield takeEvery(GetSpecialistProfile.actionTypes.load, watchGetSpecialistProfile);
}

export function useGetSpecialistProfile() {
  const { loading, data, ...specialistProfileState } = useAppSelector(
    (state) => state.specialistProfile,
  );
  const dispatch = useAppDispatch();

  const dispatchGetSpecialistProfile = useCallback((id: string | number) => {
    dispatch(GetSpecialistProfile.actions.load({ id }));
  }, [dispatch]);

  return {
    ...specialistProfileState,
    dispatchGetSpecialistProfile,
    specialistProfileLoading: loading,
    specialistProfileData: data,
  };
}

export const {
  actionTypes: specialistProfileActionsTypes,
  actions: specialistProfileActions,
  reducer: specialistProfileReducer,
} = GetSpecialistProfile;
